<mat-toolbar color="primary">
  @if (!gridStore.changes) {
    <h3>{{ 'scheduler.setup.availability-codes.title' | translate }}</h3>
  }
  @if (gridStore.changes) {
    <h3>
      <i>{{ 'scheduler.setup.availability-codes.title' | translate }}*</i>
    </h3>
  }

  <span class="spacer"></span>

  <button (click)="addRow()" class="button-margin-right" mat-flat-button>{{ 'scheduler.general.addRow' | translate }}
  </button>
  <button (click)="undo()" [disabled]="pristine" class="button-margin-right" color="warn" mat-flat-button>{{
    'scheduler.general.discardChanges' | translate }}
  </button>
  <button (click)="commit()" [disabled]="pristine" color="accent" mat-flat-button>{{ 'scheduler.general.saveChanges' |
    translate }}
  </button>

</mat-toolbar>
<div class="grid-container">
  <app-grid (gridEvents)="onEvent($event)" [columns]="columns" [filter]="true" [showContextMenu]="true"
  [showDirty]="true" [showRemoveRowInContextMenu]="true" [store]="gridStore" [width]="'calc(100vw)'"></app-grid>
</div>
<mat-paginator (page)="pageEvent = $event; selectPage();" [length]="gridStore.remoteTotal"
  [pageIndex]="gridStore.currentPage - 1" [pageSizeOptions]="pageSizeOptions" [pageSize]="gridStore.pageSize"
  hidePageSize="false" showFirstLastButtons="true">
</mat-paginator>